import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const scrollShadowFn = /* @__PURE__ */ createRecipe('ScrollShadow', {
  "orientation": "vertical"
}, [])

const scrollShadowVariantMap = {
  "orientation": [
    "vertical",
    "horizontal"
  ]
}

const scrollShadowVariantKeys = Object.keys(scrollShadowVariantMap)

export const scrollShadow = /* @__PURE__ */ Object.assign(memo(scrollShadowFn.recipeFn), {
  __recipe__: true,
  __name__: 'scrollShadow',
  __getCompoundVariantCss__: scrollShadowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: scrollShadowVariantKeys,
  variantMap: scrollShadowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, scrollShadowVariantKeys)
  },
  getVariantProps: scrollShadowFn.getVariantProps,
})